import { useEffect } from "react";
import AccountCash from "./AccountCash";
import AccountCredait from "./AccountCredait";
import AccountPass from "./AccountPass";
import AccountCheck from "./AccountCheck";
import AccountCoupon from "./AccountCoupon";
import regx from "../../../../functions/regx";
import "./accountRoute.css";



function AccountRoute ({num, setDataToPayment, dataToPayment, names, name}) {
    
    useEffect(() => {
        let funCreatePayment = () => {return true};

        switch (num) {
            case 0:
                setDataToPayment({fun: funCreatePayment});
                break;
    
            case 1:

                funCreatePayment = (dataToPayment) => {
                    if ('token' in dataToPayment || (regx('creditCard', dataToPayment.number, false)) && regx('id', dataToPayment.id, false) && regx('dateCreditCard', dataToPayment.date, false) && 
                    regx('number', dataToPayment.cvv, false)) {
                        return true;
                    } else {
                        return false;
                    }
                }

                setDataToPayment({number: "", date: "", cvv: "", id: "", typePaymentes: "Ragolar", paymentes: 1, fun: funCreatePayment});
                break;
            case 2:

                funCreatePayment = (dataToPayment) => {
                    return (regx('number', dataToPayment.account, false) && regx('number', dataToPayment.reference, false)) ? true : false
                }

                setDataToPayment({bank: "", branch: "", account: "", reference: "", fun: funCreatePayment});
                break;
            case 3:

                funCreatePayment = (dataToPayment) => {
                    // return (regx('number', dataToPayment.account, false) && regx('number', dataToPayment.checkNumber, false)) ? true : false
                    return regx('number', dataToPayment.account, false) ? true : false
                }
                
                setDataToPayment({bank: "", branch: "", account: "", checkNumber: "", date: "", fun: funCreatePayment});
                break;

            default:
                break;
        }
    }, [num])
    
    return (<>
        {
            num === 0 ? <AccountCash /> :
            num === 1 ? <AccountCredait 
            dataToPayment={dataToPayment} 
            setDataToPayment={setDataToPayment} 
            names={Object.values(names).filter(value => value['name'] === name).map(value => value['credit'])}
            /> :
            num === 2 ? <AccountPass dataToPayment={dataToPayment} setDataToPayment={setDataToPayment} /> :
            num === 3 ? <AccountCheck dataToPayment={dataToPayment} setDataToPayment={setDataToPayment} /> :
            num === 4 && <AccountCoupon />
        }
    </>)
}

export default AccountRoute;